export const localStorageSetter = (items) => {
  Object.entries(items).map(([key, value]) => {
    localStorage.setItem(key, value);
  });
};
